var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5625 22.625L20.5625 12.625C21.3125 11.8125 22.625 11.8125 23.375 12.625C24.1875 13.375 24.1875 14.6875 23.375 15.4375L16.8125 22H36C37.0625 22 38 22.9375 38 24C38 25.125 37.0625 26 36 26H16.8125L23.375 32.625C24.1875 33.375 24.1875 34.6875 23.375 35.4375C22.625 36.25 21.3125 36.25 20.5625 35.4375L10.5625 25.4375C9.75 24.6875 9.75 23.375 10.5625 22.625Z",
    fill: "#F28E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.63072cf45ae2a9f08969e406b16365ce.svg";
export { ForwardRef as ReactComponent };